import { combineReducers, configureStore } from '@reduxjs/toolkit';
import roomTypeFrontReducer from './roomType'
import faqFrontReducer from './faq'
import roomFrontReducer from './room'
import articleFrontReducer from './article'
import authFrontReducer from './auth'
import careerFrontReducer from './career'
import specialOffersFrontReducer from './specialOffers'
import amenityFrontReducer from './amenity'
import ourServiceFrontReducer from './ourServices'
import contactUsFrontReducer from './contactUs'
import homeSectionFrontReducer from './homeSection'
import aboutUsFrontReducer from './aboutusSection'
import dinningFrontReducer from './dinning'
import testimonialReducer from './testimonials'
import footerFrontReducer from './footer'
import gallerySectionFrontReducer from './gallerySection'
import meetingEventFrontReducer from './meetingEvent'
import menuAccessFrontReducer from './menuAccess'
import languageFrontReducer from './language'




const rootReducer = combineReducers({
    roomType: roomTypeFrontReducer,
    faq: faqFrontReducer,
    room: roomFrontReducer,
    article: articleFrontReducer,
    auth: authFrontReducer,
    career: careerFrontReducer,
    specialOffer: specialOffersFrontReducer,
    amenity: amenityFrontReducer,
    ourService: ourServiceFrontReducer,
    contactUs: contactUsFrontReducer,
    homeSection: homeSectionFrontReducer,
    aboutUs: aboutUsFrontReducer,
    dinning: dinningFrontReducer,
    testimonial: testimonialReducer,
    footer: footerFrontReducer,
    gallerySection: gallerySectionFrontReducer,
    meetingEvent: meetingEventFrontReducer,
    menuAccess: menuAccessFrontReducer,
    language:languageFrontReducer
});

export const store = configureStore({
    reducer: rootReducer
})

// Infer the RootState type from the store
export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;